import { render, staticRenderFns } from "./ClickOnUserModal.vue?vue&type=template&id=e2020e16"
import script from "./ClickOnUserModal.vue?vue&type=script&lang=js"
export * from "./ClickOnUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports